import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail, Lock, Loader2, Brain, ArrowLeft } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Redirect if already logged in on mount
  useEffect(() => {
    if (user && user.role === "admin") {
      navigate(location.state?.from || "/admin", { replace: true });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return toast.error("Completa los campos");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido");
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-cyan-900 to-teal-900 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 text-sm">
          <ArrowLeft size={16} /> Volver al sitio
        </Link>
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-cyan-600 to-teal-600 flex items-center justify-center text-white shadow-md">
              <Brain size={24} />
            </div>
            <div>
              <div className="font-bold text-slate-900 text-lg leading-tight">Mental Mente Sano</div>
              <div className="text-xs text-slate-500">Panel administrativo</div>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Iniciar sesión</h1>
          <p className="text-slate-600 mb-7">Accede con tus credenciales de administrador.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="admin@mentalmentesano.org"
                  className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1.5">Contraseña</label>
              <div className="relative">
                <Lock size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                  className="w-full pl-10 pr-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-cyan-600 to-teal-600 hover:shadow-lg text-white font-semibold py-3 rounded-xl transition-all disabled:opacity-60 flex items-center justify-center gap-2"
            >
              {loading ? <><Loader2 className="animate-spin" size={18} /> Entrando...</> : "Entrar"}
            </button>
          </form>
          <p className="text-xs text-slate-500 mt-6 text-center">
            ¿Olvidaste tu contraseña? Contacta al administrador del sistema.
          </p>
        </div>
      </div>
    </div>
  );
}
